export default __webpack_public_path__ + "79c20652f7bc44622f360e09fb0679b6.jpg";